import ButtonImg from './assets/peripherals/pk_button.jpg'
import PirImg from './assets/peripherals/pk_pir.jpg'
import WhLedImg from './assets/peripherals/pk_wh_led.jpg'
import Servo180Img from './assets/peripherals/pk_180_serv.jpg'
import SwitchImg from './assets/peripherals/pk_switch.jpg'
import TempImg from './assets/peripherals/pk_temp.jpg'
import RedLedImg from './assets/peripherals/pk_red_led.jpg'
import Servo360Img from './assets/peripherals/pk_360_serv.jpg'
import PotImg from './assets/peripherals/pk_pot.jpg'
import AudioImg from './assets/peripherals/pk_audio.jpg'
import NeoPixImg from './assets/peripherals/pk_neo_pix.jpg'
import PumpImg from './assets/peripherals/pk_pump.jpg'
import CrashImg from './assets/peripherals/pk_crash.jpg'
import LightImg from './assets/peripherals/pk_light.jpg'
import HuntImg from './assets/peripherals/pk_hunt.jpg'
import SoilImg from './assets/peripherals/pk_soil.jpg'
import RelayImg from './assets/peripherals/pk_relay.jpg'


const peripheralsKitData = [
  {
    title: 'Button',
    description: 'A standard momentary push button. Buttons are used in a wide variety of applications to take user input.',
    selector: 'pk_button',
    powerInput: '0 - 5V',
    image: ButtonImg,
  },
  {
    title: 'Motion Sensor',
    description: 'A PIR (Passive Infrared) Sensor measures IR Light radiating from objects. Typically used in applications such as motion lights and alarms.',
    selector: 'pk_pir',
    powerInput: '2.7 - 5V',
    image: PirImg,
  },
  {
    title: 'White LED',
    description: 'A white LED (Light Emitting Diode). Outputs a white light.',
    selector: 'pk_wh_led',
    powerInput: '2 - 5V',
    image: WhLedImg,
  },
  {
    title: '180 Servo',
    description: 'More commonly called a Positional Servo. This servo can rotate clockwise or counterclockwise 180 degrees. It can be used to move project components to a specific location.',
    selector: 'pk_180_serv',
    powerInput: '3 - 5.5V',
    image: Servo180Img,
  },
  {
    title: 'Switch',
    description: 'This switch locks into place when pressed. Switches are generally used to apply power or change a setting.',
    selector: 'pk_switch',
    powerInput: '0 - 5V',
    image: SwitchImg,
  },
  {
    title: 'Temperature Sensor',
    description: 'Can read a raw value of the temperature. Requires some calibration to provide a specific temperature value in C or F.',
    selector: 'pk_temp',
    powerInput: '2.7 - 5.5V',
    image: TempImg,
  },
  {
    title: 'Red LED',
    description: 'A red LED (Light Emitting Diode). Outputs a red light.',
    selector: 'pk_red_led',
    powerInput: '2 - 5V',
    image: RedLedImg,
  },
  {
    title: '360 Servo',
    description: 'More commonly called a Continuous Rotation Servo. This servo can rotate 360 degrees. It operates continuously in the clockwise or counterclockwise direction.',
    selector: 'pk_360_serv',
    powerInput: '3 - 5.5V',
    image: Servo360Img,
  },
  {
    title: 'Potentiometer',
    description: 'Often referred to as a knob. The potentiometer can be physically turned. It returns a value based on the position it is set to.',
    selector: 'pk_pot',
    powerInput: '3 - 5V', // elecfreaks website says only for 5V... should work at 3V
    image: PotImg,
  },
  {
    title: 'Sound Sensor',
    description: 'This sensor is sensitive to sound intensity. It can be used to detect noises.',
    selector: 'pk_audio',
    powerInput: '3 - 5V',
    image: AudioImg,
  },
  {
    title: '8 RGB LED Ring',
    description: '8 RGB (Red Green Blue) LED Ring. Also called a NeoPixel ring. This device has 8 individual RGB LED pixels. Pixels can be illuminated any color and assigned individually.',
    selector: 'pk_neo_pix',
    powerInput: '4 - 7V', // elecfreaks website says will not work at 3V
    image: NeoPixImg,
  },
  {
    title: 'Water Pump',
    description: 'This is a small water pump. It is designed for vertical, submersible operations and can be used to transfer water from one location to another.',
    selector: 'pk_pump',
    powerInput: '3 - 4.5V',
    image: PumpImg,
  },
  {
    title: 'Microswitch',
    description: 'The microswitch is used in a wide variety of applications. Operationally, it is nothing more than a button. It can be used as a crash sensor to detect robot touch.',
    selector: 'pk_crash',
    powerInput: '0 - 5V',
    image: CrashImg,
  },
  {
    title: 'Light Sensor',
    description: 'The photocell is used to measure the amount of ambient light. Many uses such as smoke detection, solar monitoring, and light dimming.',
    selector: 'pk_light',
    powerInput: '0 - 5V',
    image: LightImg,
  },
  {
    title: 'Object Sensor',
    description: 'Sometimes referred to as a Hunt Sensor. It contains an LED that emits Infrared (IR) light, and a Phototransistor that detects IR light reflected from nearby objects. Many uses such as object detection and line following.',
    selector: 'pk_hunt',
    powerInput: '3 - 5V', // from the elecfreaks website.  should work at 3V?
    image: HuntImg,
  },
  {
    title: 'Soil Moisture Sensor',
    description: 'Detects the amount of moisture present in the soil surrounding it. Most often used to determine when a plant needs water.',
    selector: 'pk_soil',
    powerInput: '3.3 - 5V',
    image: SoilImg,
  },
  {
    title: '3V Relay',
    description: 'Can be used to switch larger power and voltages to devices. Could be used for a DC Motor or an AC Lamp. Contact Ratings: 2A 120VAC / 2A 24VDC',
    selector: 'pk_relay',
    powerInput: '2.5 - 3.9V',
    image: RelayImg,
  },
]

export default peripheralsKitData
